import { DEFAULT_OPTION } from 'constants/general';

const getValueOption = (list: { label: string, value: string }[], value: string) => {
  const findItem = list.find((item) => item.value === value);
  return findItem || DEFAULT_OPTION;
};

export default getValueOption;
